class AlgoliaInstantSearch extends HTMLElement {
  constructor() {
    super();
    console.log("algolia instant search");

    this.skus = [];
    this.vehicle_ids = [];
    this.activeVehicleIds = [];
    this.selectedYear = 0;
    this.brands = this.getAttribute("data-vendors")
      ? this.getAttribute("data-vendors").split(",")
      : [];
    this.product_types = this.getAttribute("data-product-types")
      ? this.getAttribute("data-product-types").split(",")
      : [];
    this.facets = this.getAttribute("data-facets")
      ? this.getAttribute("data-facets").split(",")
      : [];
    this.filters = this.getAttribute("data-filters");
    this.showVehicleSearch =
      this.getAttribute("data-show-vehicle-search") === "true";

    this.partbot_vehicle = localStorage.getItem("partbot_selected_vehicle");
    this.platesearch_ids = [];

    this.facetFiltersContainer = this.querySelector("#facet-filters");

    if (this.showVehicleSearch && this.partbot_vehicle) {
      this.partbot_vehicle = JSON.parse(this.partbot_vehicle);
      this.platesearch_ids = this.partbot_vehicle.vehicle_ids;

      const vehicleDescription = document.querySelector(
        ".js-vehicle-description"
      );

      console.log("vehicleDescription", vehicleDescription);
      console.log("this.partbot_vehicle", this.partbot_vehicle);

      vehicleDescription.textContent = this.partbot_vehicle.description;

      const clearButton = document.querySelector(".js-button-clear-vehicle");
      clearButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        localStorage.removeItem("partbot_selected_vehicle");
        localStorage.removeItem("partbot_plate_details");
        location.reload();
      });

      document
        .querySelector(".js-selected-vehicle-notice")
        .classList.remove("hidden");
      document
        .querySelector(".js-selected-vehicle-notice")
        .classList.add("flex");

      document.querySelector("vehicle-search").classList.add("hidden");
    }

    // configure Algolia
    // this.algoliaAppId = this.getAttribute("data-algolia-app-id");
    // this.algoliaApiKey = this.getAttribute("data-algolia-api-key");
    // this.algoliaIndexName = this.getAttribute("data-algolia-index");

    this.hitsContainer = this.querySelector("#main-collection-product-grid");

    this.algoliaAppId = "J6KPA5IUUA";
    this.algoliaApiKey = "1e5494ec5c7bf916a5a9bf611b6c3250";
    this.algoliaIndexName = "shopify_jackbeedham_production";

    // listen for vehicle search changes
    this.onVehicleSearchChange = this.applyVehicleSearchSelection.bind(this);
    this.filterAlgoliaHits = this.processHits.bind(this);

    const searchClient = algoliasearch(this.algoliaAppId, this.algoliaApiKey);
    this.search = instantsearch({
      indexName: this.algoliaIndexName,
      searchClient,
      routing: false,
      searchFunction: function (helper) {
        if (this.vehicle_ids) {
          this.vehicle_ids.map((id) => {
            helper.addDisjunctiveFacetRefinement("vehicle_ids", id);
          });
          this.vehicle_ids = [];
        }
        helper.search();
      },
    });

    const vehicleIdFilter = this.showVehicleSearch
      ? `vehicle_ids:${this.platesearch_ids.join(",")}`
      : [];

    this.search.addWidget(
      instantsearch.widgets.configure({
        hitsPerPage: 15,
        distinct: true,
        filters: this.filters,
        facetFilters: [
          this.brands.map((b) => `vendor:${b}`),
          this.product_types.map((p) => `product_type:${p}`),
          vehicleIdFilter,
        ].filter((f) => f),
        facetingAfterDistinct: true,
        facets: [
          "vendor",
          "product_type",
          "vehicle_years.year_from",
          "vehicle_years.year_to",
          "attributes",
        ].concat(this.facets),
        disjunctiveFacets: [
          "vendor",
          "product_type",
          "vehicle_years.year_from",
          "vehicle_years.year_to",
          "vehicle_ids",
          "attributes",
        ],
        numericFilters: ["price>0"],
      })
    );

    // Add Facet Filters
    if (this.facets && this.facets.length) {
      this.facets.forEach((facet) => {
        let node = document.createElement("div");
        node.innerHTML = `<div class='filter-title'>${facet
          .replace(/_/g, " ")
          .replace("vendor", "brand")}</div><div id='filter-${facet}'></div>`;

        let attr_title = ["brand", "vendor", "product_type"].find((v) =>
          facet.includes(v)
        )
          ? facet.replace("brand", "vendor")
          : `attributes.${facet}`;

        this.facetFiltersContainer.appendChild(node);
        this.search.addWidgets([
          instantsearch.widgets.refinementList({
            container: `#filter-${facet}`,
            attribute: attr_title,
            operator: "and",
            limit: 10,
            sortBy: ["title:desc"],
            templates: {
              item: document.querySelector("#algolia-filter-template")
                .innerHTML,
            },
            cssClasses: {
              list: "mb-8",
            },
          }),
        ]);
      });
    }

    this.search.addWidget(
      instantsearch.widgets.pagination({
        container: "#pagination",
        autoHideContainer: true,
        padding: 1,
        scrollTo: "#main-collection-product-grid",
        templates: {
          first: "First",
          previous: "←",
          next: "→",
          last: "Last",
        },
        cssClasses: {
          list: "pages text-center flex justify-start space-x-3 p-6",
          selectedItem: "active",
          link: "btn-pill flex justify-center",
          disabledItem: "disabled hidden",
          firstPageItem: "control",
          lastPageItem: "control",
          nextPageItem: "control",
          previousPageItem: "control",
        },
      })
    );

    // Add Hits Widget

    const filterM = this.filterAlgoliaHits;
    let _this = this;
    this.search.addWidget(
      instantsearch.widgets.hits({
        container: "#main-collection-product-grid",
        cssClasses: {
          list: `grid md:grid-cols-2 ${
            this.facets.length > 0
              ? "lg:grid-cols-3 xl:grid-cols-4"
              : "lg:grid-cols-4 xl:grid-cols-5"
          }`,
        },
        templates: {
          item: document.querySelector("#algolia-hit-template").innerHTML,
          empty: document.querySelector("#algolia-empty-template").innerHTML,
        },
        transformItems(items) {
          _this.skus = [];

          return items.filter(filterM, this).filter((i) => i);
        },
      })
    );

    // Let's start the show...
    this.search.start();

    // Listen for vehicle search changes
    document.addEventListener(
      "vehicle-search-change",
      this.onVehicleSearchChange
    );
  }

  processHits(item) {
    if (this.selectedYear) {
      // collect all year_froms <= selectedYear and year_tos >= selectedYear
      var yf_vehicle_ids = [];
      var yt_vehicle_ids = [];
      var yf_permitted, yt_permitted;
      if (
        item.hasOwnProperty("vehicle_years") &&
        item.vehicle_years.hasOwnProperty("year_from") &&
        item.vehicle_years.hasOwnProperty("year_to")
      ) {
        // collect year_froms
        for (var year in item.vehicle_years.year_from) {
          if (year <= this.selectedYear) {
            yf_vehicle_ids.push(item.vehicle_years.year_from[year]);
          }
        }

        // collect year_tos
        for (var year in item.vehicle_years.year_to) {
          if (year >= this.selectedYear) {
            yt_vehicle_ids.push(item.vehicle_years.year_to[year]);
          }
        }

        yf_vehicle_ids = yf_vehicle_ids.flat();
        yt_vehicle_ids = yt_vehicle_ids.flat();

        yf_permitted = this.activeVehicleIds.filter((n) =>
          yf_vehicle_ids.includes(n)
        );

        yt_permitted = this.activeVehicleIds.filter((n) =>
          yt_vehicle_ids.includes(n)
        );

        // remove from results if not permitted
        if (yf_permitted.length === 0 || yt_permitted.length === 0) {
          return false;
        }
      }
    }

    if (!this.skus.includes(item.sku)) {
      this.skus.push(item.sku);
      // console.log("skus", this.skus);
    } else {
      return false;
    }

    item.afterpay_price = parseFloat(item.price / 4).toFixed(2);

    return item;
  }

  applyVehicleSearchSelection(e) {
    if (this.platesearch_ids && this.platesearch_ids.length) {
      console.log(
        "check partbot_vehicle in onVehicleSearchChange",
        this.partbot_vehicle
      );
      return false;
    }

    if (!this.search.helper) {
      this.vehicle_ids = e.detail.vehicle_ids;
      return false;
    }
    this.search.helper.clearRefinements("vehicle_ids");

    if (e.detail.vehicle.make) {
      this.search.helper.setQuery(e.detail.vehicle.make.value);
    } else {
      this.search.helper.setQuery("");
    }

    if (e.detail.vehicle.year) {
      this.selectedYear = parseInt(e.detail.vehicle.year.value);
    } else {
      this.selectedYear = null;
    }

    this.activeVehicleIds = e.detail.vehicle_ids;

    if (this.activeVehicleIds) {
      this.activeVehicleIds.map((id) => {
        this.search.helper.addDisjunctiveFacetRefinement("vehicle_ids", id);
      });

      this.search.helper.search();
    }
  }
}

customElements.define("algolia-instant-search", AlgoliaInstantSearch);
